import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-door",
  "use": "icon-door-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-door\">\n<rect x=\"22.474\" y=\"87.08\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#8FC31F\" stroke=\"#009944\" stroke-width=\"5.79\" stroke-miterlimit=\"22.9256\" width=\"155.051\" height=\"25.839\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol